/**
 * Pagal kalbą grąžina pavadinimą arba aprašymą iš daugiakalbių laukų.
 * Laukai: name (LT), name_en, name_de; description (LT), description_en, description_de.
 * @param {Object} item - Objektas su name, name_en, name_de (arba description, description_en, description_de)
 * @param {string} lang - 'lt' | 'en' | 'de'
 * @param {'name'|'description'} field - Kurį lauką grąžinti
 * @returns {string}
 */
function getLocalizedField(item, lang, field) {
  if (!item) return '';
  const prefix = field === 'name' ? 'name' : 'description';
  const val = lang === 'en' ? (item[`${prefix}_en`] ?? item[prefix]) : lang === 'de' ? (item[`${prefix}_de`] ?? item[prefix]) : (item[prefix] ?? item[`${prefix}_en`] ?? item[`${prefix}_de`]);
  return val != null ? String(val).trim() : '';
}

export function getCategoryName(category, lang) {
  return getLocalizedField(category, lang || 'lt', 'name');
}

export function getCategoryDescription(category, lang) {
  return getLocalizedField(category, lang || 'lt', 'description');
}
